export default __webpack_public_path__ + "static/media/icon-planning.319dbfea.svg";